// TSS vite/04 §"Endpoint paths". URL knowledge kept local to the feature.
// baseURL already includes /api/v1 (see global/config/api).

export const clientPaths = {
    list:         ()    => 'admin/clients',
    detail:       (id)  => `admin/clients/${id}`,
    holdings:     (id)  => `admin/clients/${id}/holdings`,
    portalInvite: (id)  => `admin/clients/${id}/portal-invite`,
    linkUser:     (id)  => `admin/clients/${id}/link-user`,
    setPassword:  (id)  => `admin/clients/${id}/set-password`,
};
